import React, { useRef } from 'react';
import ProTable from '@ant-design/pro-table';
import { Tag } from 'antd';
import { revokePageList } from '@/services/userManager';
const DelClassRecordView = (props) => {
  // eslint-disable-next-line react/prop-types
  const { userId, userPhone } = props;
  /// 销课记录
  const delClassTableRef = useRef();
  const delClassTableColumns = [
    {
      title: '商品权益',
      dataIndex: 'rightsName',
      render: (text, record) => {
        if (text === '-') {
          return text;
        }
        return (
          <>
            <Tag color="#7e80f3">{record.rightsTag}</Tag> {text}
          </>
        );
      },
    },
    {
      title: '购买时间',
      dataIndex: 'buyTime',
    },
    {
      title: '销课方式',
      dataIndex: 'revokeType',
      valueType: 'select',
      valueEnum: {
        0: { text: '新增' },
        1: { text: '上课锁定' },
        2: { text: '取消锁定' },
        3: { text: '上课核销' },
        4: { text: '订单退款' },
        5: { text: '权益到期' },
        6: { text: '后台手动核销' },
        7: { text: '爽约扣销 ' },
      },
    },
    {
      title: '操作人',
      dataIndex: 'operator',
    },
    {
      title: '操作时间',
      dataIndex: 'createTime',
    },
    {
      title: '权益类型',
      dataIndex: 'spRightsTypeName',
      render: (text, record) => {
        if (text === '-') {
          return text;
        }
        return (
          <>
            <Tag
              color={
                record?.spRightsType == 1 || record?.spRightsType == 3
                  ? 'green'
                  : 'orange'
              }
            >
              {text}
            </Tag>
          </>
        );
      },
    },
    {
      title: '销课课时',
      dataIndex: 'revokeNum',
    },
    {
      title: '课表ID',
      dataIndex: 'relId',
      render: (text, record, index, action) => {
        const { relId, revokeType ,relStartDate} = record;

        return (
          <>
            {revokeType == 3 || revokeType == 7 ? (
              <a
                onClick={() => {
                  window.open(
                    `/operating/curriculum?roomId=${relId}&startTimeInit=${relStartDate||undefined}`,
                    '_blank',
                  );
                }}
                style={{ textDecoration: 'underline', color: '#333' }}
              >
                {relId}
              </a>
            ) : (
              '-'
            )}
          </>
        );
      },
    },
    {
      title: '上课人',
      dataIndex: 'classUserRelation',
      render: (text, record) => {
        if (text === '-') {
          return text;
        }
        return (
          <>
            <Tag>{text}</Tag> {record.classUserPhone}
          </>
        );
      },
    },
  ];
  return (
    <ProTable
      columns={delClassTableColumns}
      actionRef={delClassTableRef}
      request={async (params) => {
        const { data, page, code } = await revokePageList({
          requestData: {
            ...params,
            phone: userPhone,
            userId: userId,
          },
          page: {
            currentPage: params.current,
            pageSize: params.pageSize,
          },
        });
        if (code !== '00000') {
          return {
            success: false,
          };
        }
        return {
          data: data,
          success: true,
          total: page.count,
        };
      }}
      columnsState={{
        persistenceKey: 'pro-table-singe-demos2',
        persistenceType: 'localStorage',
      }}
      // rowKey={(record) => record.id}
      rowKey="id"
      search={false}
      scroll={{ x: 'max-content' }}
      pagination={{
        defaultPageSize: 10,
      }}
      dateFormatter="string"
      toolBarRender={false}
    />
  );
};

export default DelClassRecordView;
